import FormJaivana from 'dashboard_jaivana_v1';

/**
 *
 * @author Juan Camilo Villa
 * @modified 07-01-2025
*/
/**
 * CustomVendingMaquinas
**/
class CustomVendingMaquinas extends FormJaivana.form {


   constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);
        this.gridOptionsTbPrincipal = Object.assign({},this.gridOptions);
        this.arrayPrincipal = [];
        this.arrayPrincipalMaquines = [];

        this.getAllMachinesNoacloud = this.getAllMachinesNoacloud.bind(this);
        this.successGetAllMachinesNoacloud = this.successGetAllMachinesNoacloud.bind(this);
        
        this.getAllVendingMachines = this.getAllVendingMachines.bind(this);
        this.successGetAllVendingMachines = this.successGetAllVendingMachines.bind(this);
        
        this.updateRegister = this.updateRegister.bind(this);
        this.successUpdateMachines = this.successUpdateMachines.bind(this);
        
        this.setButtonModificar = this.setButtonModificar.bind(this);
        this.crearBotonTabla = this.crearBotonTabla.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.successEditarDependencyId = this.successEditarDependencyId.bind(this);

        this.objectTabla = {nit: '', sede: 0, serial: '', nitsx_sedes_id: 0};

        this.editarDependencyId = this.editarDependencyId.bind(this);
        this.gridOptionsTbPrincipal['onSelectionChanged']  =   this.onSelectionChanged;

    }

    initForm() {
       console.log('CustomVendingMaquinas,  @version: jdesk_1.01.0001, @author: Juan Camilo Villa');
       /* this.getAllMachinesNoacloud(); */
        this.getAllVendingMachines();
        this.getField('btn_manejo_maquinas_dispensaciones').setClick(this.getAllMachinesNoacloud);
        this.getField('modal_modificar_nit').setHandlerClose(this.closeModal);
        this.getField('btn_modal_modificar_nit').setClick(this.updateRegister);
        this.getField('nombreNit').setDisabled(true);
        this.getField('sedeNit').setDisabled(true);

        this.getField('nombre_bodega').setDisabled(true);
        this.getField('nombre_sucursal').setDisabled(true);
        this.getField('detalle_facturacion').setDisabled(true);
        this.getField('nombre_vendedor').setDisabled(true);

    }

    /**
     * obtiene y actualizan todas las máquinas
     */
    getAllMachinesNoacloud(){
        let datos={ datos: {}};

        this.generalFormatPmv = { tipo_servicio: 'inte-maquinasvending', operacion: 'machines', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successGetAllMachinesNoacloud,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
                
        });
    }

    successGetAllMachinesNoacloud(data){
        if (data.estado_p === 200) {
            this.arrayPrincipalMaquines = data.data;
            this.getAllVendingMachines();
            /* this.updateRegister(); */
        }else{
            if (data.hasOwnProperty('mensaje')) {
                let objectMessageError = data.mensaje;
                if (objectMessageError.includes('Access token expired')) {
                    this.alertGeneral.toggle(true, 'Error!!  Token Expirado', 'error');
                } else {

                    this.alertGeneral.toggle(true, 'Error obteniendo máquinas Noacloud', 'error');
                }

            }else{
                this.alertGeneral.toggle(true, 'Error obteniendo máquinas Noacloudddd', 'error');
            }
        }
    }

    /**
     * Trae toda la información de los clientes con sus respectivas máquinas asociadas
     */
    getAllVendingMachines(){
        let datos={ datos: {
        }};

        this.generalFormatPmv = { tipo_servicio: 'inte-maquinasvending', operacion: '1', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successGetAllVendingMachines,
                error: this.error_,
                general: this.generalFormatPmv,
        });
    }



    successGetAllVendingMachines(data){
        if (data.estado_p === 200) {
            this.getField('tabla_maquinas').toggle(true);
            this.arrayPrincipal = data.data
            this.gridOptionsTbPrincipal['rowData'] = this.arrayPrincipal;
            /* this.gridOptionsTbPrincipal['onSelectionChanged'] = this.gridOptionsTbPrincipal.api.getSelectedRows(); */
            let configCell = new Map();
            configCell.set('sc_dependency_id', { cellRenderer:function(props){return props.data.sc_dependency_id},onCellValueChanged:this.editarDependencyId, cellStyle: {backgroundColor: "rgb(238,238,238)",borderRadius:"5px",color:'rgb(0, 86, 201)' }, editable: true ,sortable: false, filter: false, });
            configCell.set('accion', { cellRenderer: this.setButtonModificar, headerName: 'Acción', width: 200, sortable: false,  filter: false });
            

            this.getField('tabla_maquinas').initData(this.gridOptionsTbPrincipal, configCell);

        }else{
            this.gridOptionsTbPrincipal['rowData'] = [];
            this.getField('tabla_maquinas').toggle(false);
        }
    }

    editarDependencyId(props){
        let seguir = this.getField('tabla_maquinas').cellValid(props.oldValue,props.newValue,'^[0-9]+$'); 
        const nuevoValor = props.newValue !== undefined && props.newValue !== null ? props.newValue.toString() : '';

        if (nuevoValor.length >= 10) {
            seguir = false;
        }

        if (seguir) {
            let row_selected = this.gridOptionsTbPrincipal.api.getSelectedRows()[0]['serial'];

            let datos={ datos: {
                serial: row_selected,
                sc_dependency_id: parseInt(props.newValue)
            }};
            
            this.generalFormatPmv = { tipo_servicio: 'inte-maquinasvending', operacion: '5', operacion_tipo: 'consulta' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successEditarDependencyId,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                    
            });
        }else {
            this.alertGeneral.toggle(true, 'No puede ingresar valores diferentes a números enteros o exceder 10 dígitos.', 'error');
            this.getAllVendingMachines();
        }
    }

    successEditarDependencyId(data){
        if (data.estado_p === 200 || data.estado_p === 404) {
            this.getAllVendingMachines()
        }else{
            this.alertGeneral.toggle(true, 'No se pudo actualizar el registro', 'error');
        }

    }



    /**
 * Establece la creación del botón en la tabla
 * @param {Contiene los valores de la fila seleccionada en la tabla} props 
 */
    setButtonModificar(props) {
        let fragment = document.createDocumentFragment();
        let buttonImage = this.crearBotonTabla(props.data, 'Modificar');
        fragment.appendChild(buttonImage); 
        return this.createElementJaivana(fragment)
        
    }

    crearBotonTabla(data, nombreBoton) {
        let button = document.createElement('input');
        button.setAttribute("class", "buttonStyleImg");
        button.onclick = () => { this.accionModificarNit(data) };
        button.setAttribute('value', nombreBoton);
        button.setAttribute('type', 'button');
        button.setAttribute("class", "buttonStyle2");
        button.setAttribute("id", `accionModificarNit_${data.id}`);
        return button;
    }

    accionModificarNit(data) {
        this.objectTabla['nit'] = data.nit_cliente;
        this.objectTabla['sede'] = data.sede;
        this.objectTabla['serial'] = data.serial;
        this.objectTabla['nitsx_sedes_id'] = data.nitsx_sedes_id;
        this.getField('modal_modificar_nit').handleClickOpen();


        this.getField('buscador_nit').setValue(data.nit_jaivana);
        this.getField('sedeNit').setValue(data.sede);
        this.getField('nombreNit').setValue(data.nombre_jaivana);        
        this.getField('codigo_bodega').setValue(data.codigo_bodega);
        this.getField('nombre_bodega').setValue(data.nombre_bodega);
        this.getField('codigo_sucursal').setValue(data.codigo_sucursal);
        this.getField('nombre_sucursal').setValue(data.nombre_sucursal);
        this.getField('codigo_facturacion').setValue(data.codigo_facturacion);
        this.getField('detalle_facturacion').setValue(data.detalle_facturacion);
        this.getField('codigo_vendedor').setValue(data.codigo_vendedor);
        this.getField('nombre_vendedor').setValue(data.nombre_vendedor)
    }
    
    closeModal(){
        this.objectTabla = {nit: '', sede: 0, serial:'', nitsx_sedes_id: 0};
        this.getField("modal_modificar_nit").handleCloseButton();
    }


    updateRegister(){
        if (this.getField('buscador_nit').valid() && this.getField('sedeNit').valid() 
        && this.getField('nombreNit').valid() && this.getField('nombre_bodega').valid() && this.getField('nombre_sucursal').valid()
        && this.getField('detalle_facturacion').valid() && this.getField('nombre_vendedor').valid()  && this.objectTabla['serial'] !== '') {
            
            let datos={ datos: {
                /* nit: this.getField('buscador_nit').getValue(), */
                nitsx_sedes_id: this.getField('nitsx_sedes_id').getValue(),
                sede: this.getField('sedeNit').getValue(),
                serial: this.objectTabla['serial'],

                codigo_bodega: this.getField('codigo_bodega').getValue(),
                codigo_sucursal: this.getField('codigo_sucursal').getValue(),
                codigo_facturacion: this.getField('codigo_facturacion').getValue(),
                codigo_vendedor: this.getField('codigo_vendedor').getValue(),
            }};
            
            this.generalFormatPmv = { tipo_servicio: 'inte-maquinasvending', operacion: '6_5', operacion_tipo: 'consulta' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successUpdateMachines,
                    error: this.error_,
                    general: this.generalFormatPmv,
            });
            
        } else {
            this.alertGeneral.toggle(true, 'No hay datos para actualizar' , 'error');
        }
    }

    successUpdateMachines(data){
        this.getField('nitsx_sedes_id').setValue('');
        this.getField('sc_dependency_id').setValue('');
        this.getField('serial').setValue('');
        if (data.estado_p === 200) {
            this.getAllVendingMachines();
            this.getField("modal_modificar_nit").handleClose();
        }
    }
    

}
FormJaivana.addController('inte-maquinasvending',CustomVendingMaquinas);
export default CustomVendingMaquinas;